import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import * as HttpStatus from 'http-status-codes';
import * as $ from 'jquery';

import { UsersService } from '../../services/users.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

@Component({
  selector: 'profile-container',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  API = this.helper.getApi();
  vals = {};
  formElements = [];
  dropdownSelection = [];
  dropdownSelection2: string;
  helperDrpdwKeys = [];
  data = {};
  _id = -1;
  token = '';
  notification = { message: '', type: '' };
  insurances = this.helper.getInsurance();
  type: string;
  superClinicId: string;
  preselectedClinic: string;
  service: string;
  singleClinic: string;
  aalborgFlow: boolean;
  showPasswords: boolean;
  noEmail: boolean;
  noCpr: boolean;
  nationality: any;
  danmNr: any;
  insuranceCompany: any;
  currentUser: any = this.helper.getStorage("currentUser");
  allClinics: Array<any> = this.helper.getStorage("allClinics");
  readonly countries: any = Constants.COUNTRIES;
  readonly groups: any = Constants.GROUPS;
  readonly flowName: any = Constants.FLOW_TYPE;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private router: Router,
    public usersService: UsersService
  ) {}

  ngOnInit() {
    const user: any = this.helper.getStorage("currentUser");

    if (user) {
      this.data = user.data;
      this._id = user._id;
      this.token = user.token;
    }

    let data = this.data;

    this.nationality = data['nationality'];

    let formElements = [
      {
        key: 'cprNr',
        label: 'CPR-nr.',
        required: true,
        controlType: 'text',
        value: data['CPRNumber'],
        pattern:
          '(?:0[1-9]|[12][0-9]|3[01])(?:0[1-9]|1[012])(?:[0-9]{2})-?[0-9]{4}',
        errors: {
          pattern: 'Skriv CPR som 10 cifre uden skilletegn.',
          custom: 'Ugyldigt CPR',
        },
      },
      {
        key: 'danmNr',
        label: 'Danmarksgruppe',
        required: true,
        controlType: 'dropdown',
        value: data['danmNr'],
        vals: this.groups,
      },
      {
        value: data['insuranceCompany'],
        key: 'insuranceCompany',
        label: 'Forsikringsselskab',
        required: false,
        controlType: 'dropdown',
        vals: this.insurances,
      },
      {
        key: 'firstName',
        label: 'Fornavn',
        required: true,
        controlType: 'text',
        value: data['firstName'],
        errors: { pattern: 'Fornavn skal udfyldes!' },
      },
      {
        key: 'lastName',
        label: 'Efternavn',
        required: true,
        value: data['lastName'],
        controlType: 'text',
        errors: { pattern: 'Efternavn skal udfyldes' },
      },
      {
        key: 'address',
        label: 'Adresse',
        required: true,
        controlType: 'text',
        value: data['address'],
        pattern: '[a-zA-Z0-9 .,-ÅåÆæØø]{2,}',
        errors: { pattern: 'Adresse skal udfyldes!' },
      },
      {
        key: 'postalNr',
        label: 'Postnr.',
        required: true,
        controlType: 'text',
        value: data['postalNr'],
        pattern: '',
        errors: { pattern: 'Postnummer skal udfyldes!' },
      },
      {
        key: 'city',
        label: 'By',
        required: true,
        controlType: 'text',
        value: data['city'],
        pattern: '[a-zA-Z0-9 .,-åæéøÅÆÉØ]{2,}',
        errors: { pattern: 'By skal udfyldes!' },
      },
      {
        key: 'nationality',
        label: 'Nationalitet',
        required: false,
        controlType: 'dropdown',
        value: data['nationality'],
        vals: this.countries,
      },
      {
        key: 'email',
        label: 'Email',
        required: true,
        controlType: 'email',
        value: data['email'],
        pattern: '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+',
        errors: {
          pattern:
            "Email skal udfyldes og skal formateres 'adresse@domain.xx'!",
        },
      },
      {
        key: 'phoneNr',
        label: 'Telefon',
        required: false,
        controlType: 'number',
        value: data['phoneNr'],
      },
      {
        key: 'cellNr',
        label: 'Mobil',
        required: true,
        controlType: 'text',
        value: data['cellNr'],
        pattern: '[0-9+-]{6,18}',
        errors: { pattern: 'Mobil tlf. skal udfyldes!' },
      },
    ];

    formElements.map((el) => (this.vals[el.key] = el.value));

    this.formElements = formElements;
    this.currentUser = this.helper.getStorage("currentUser");

    // preselect dropdowns
    this.setDropdownSelection('nationality', {
      value: this.currentUser.data.nationality,
      key: 'key',
    });

    this.setDropdownSelection('danmNr', {
      value: this.currentUser.data.danmNr
        ? this.currentUser.data.danmNr
        : '- Ingen -',
      key: 'key',
    });

    this.setDropdownSelection('insuranceCompany', {
      value: this.currentUser.data.insuranceCompany
        ? this.currentUser.data.insuranceCompany
        : '- Ingen -',
      key: 'key',
    });

    this.route.queryParams.subscribe((params: Params) => {
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.type = params.type;
      this.service = params.service;
      this.singleClinic = params.singleClinic;
      this.noEmail = params.noEmail;
      this.noCpr = params.noCpr;

      if (params.type === this.flowName.aalborg) {
        this.aalborgFlow = true;
      } else {
        this.aalborgFlow = false;
      }
    });

    if (this.dropdownSelection == undefined) {
      this.currentUser = this.helper.getStorage("currentUser");
      this.dropdownSelection = this.currentUser.data.danmNr;
    }

    if (this.dropdownSelection2 == undefined) {
      this.currentUser = this.helper.getStorage("currentUser");
      this.dropdownSelection2 = this.currentUser.data.insuranceCompany;
    }
  }

  setDropdownSelection(key: any, data: any) {
    let item;
    const formElement = this.formElements.find((el) => el.key === key);

    formElement.value = data.value;

    item = {
      key: formElement.key,
      value: data.value,
      data: data.key,
      default: formElement.label,
    };

    const dropdownItem = item;

    if (this.dropdownSelection.filter((e) => e.key === dropdownItem.key).length > 0) {
      this.dropdownSelection.map((elem, i) => {

        if (elem.key == dropdownItem.key) {
          this.dropdownSelection[i] = dropdownItem;
          this.helperDrpdwKeys[i] = dropdownItem.key;
        }
      });
    } else {
      this.dropdownSelection.push(dropdownItem);
      this.helperDrpdwKeys.push(dropdownItem.key);
    }

    // set dropdown values
    if (dropdownItem.key === 'nationality') {
      this.nationality = dropdownItem.value;
    }

    if (dropdownItem.key === 'danmNr') {
      this.danmNr = dropdownItem.value;
    }

    if (dropdownItem.key === 'insuranceCompany') {
      this.insuranceCompany = dropdownItem.value;
    }
  }

  onKey(event: any, key) {

    if (key === 'cprNr') {
      event.target.value = event.target.value.replace(/[^\d]/, '');

      if (event.target.value.length > 10) {
        event.target.value = event.target.value.substr(0, 10);
      }
    } else {
      this.vals[key] = event.target.value;
    }
  }

  showPasswordFields() {
    this.showPasswords = !this.showPasswords;
  }

  updateProfile() {
    const pass = $('#password').val();
    const repeat_pass = $('#repeatPassword').val();
    const data = {
      _id: this._id,
      data: {
        CPRNumber: $('#cprNr').val(),
        firstName: $('#firstName').val(),
        lastName: $('#lastName').val(),
        address: $('#address').val(),
        postalNr: $('#postalNr').val(),
        city: $('#city').val(),
        nationality: this.nationality,
        email: $('#email').val(),
        cellNr: $('#cellNr').val(),
        phoneNr: $('#phoneNr').val(),
        danmNr: this.danmNr,
        insuranceCompany: this.insuranceCompany,
        username: $('#cprNr').val(),
        clinicId: this.data['clinicId'],
        complimentaId: this.data['complimentaId'],
      },
    };

    if (pass !== '') {
      data['data']['password'] = pass;

      if (pass !== repeat_pass) {
        this.notification = {
          message: 'Adgangskoder stemmer ikke overens',
          type: 'error',
        };

        return false;
      }
    }

    this.usersService
      .updateProfile(data)
      .subscribe((profileResponse) => {
        this.handleSuccess(profileResponse, data)
      });
  }

  handleSuccess(profileResponse, data) {
   
    if (profileResponse.status === HttpStatus.OK) {
      this.notification = { message: 'Profil opdateret', type: 'success' };

      localStorage.setItem(
        'currentUser',
        JSON.stringify({
          _id: this._id,
          data: data.data,
          token: this.helper.getToken(),
        })
      );

      if (this.noEmail || this.noCpr) {
        const params = {
          type: this.type,
          service: this.service,
          singleClinic: this.singleClinic,
        };

        // if superclinic and superclinic + service flow, send params to next page
        if (this.superClinicId) {
          params['superClinicId'] = this.superClinicId;
        }

        // if singleclinic flow, send clinics params to next page
        if (this.singleClinic === 'true') {
          params['clinics'] = this.preselectedClinic;
        }

        const navigationExtras: NavigationExtras = {
          queryParams: params,
        };

        setTimeout(() => {
          const current_user: any = this.helper.getStorage("currentUser");

          if (
            current_user &&
            current_user.data.email &&
            current_user.data.email !== undefined && 
            current_user.data.CPRNumber &&
            current_user.data.CPRNumber !== undefined
          ) {
            this.router.navigate(['/welcome'], navigationExtras);
          } else {
            localStorage.clear();

            this.router.navigate(['/login'], navigationExtras);
          }
        }, 1500);
      }
    } else {
      this.notification = {
        message: 'Indtastede e-mail adresse er i brug  - forsøg med en anden e-mail adresse.',
        type: 'error',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.component.ts